import { useState, useCallback, useEffect } from 'react';
import PlanetScene from './components/PlanetScene';
import SectionPanel from './components/SectionPanel';
import NavigationArrows from './components/NavigationArrows';
import HeroOverlay from './components/HeroOverlay';
import { sections } from './data/portfolioData';

export default function App() {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [isZoomed, setIsZoomed] = useState(false);

  const handleSelect = useCallback((index: number) => {
    setSelectedIndex(index);
    setIsZoomed(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsZoomed(false);
    setTimeout(() => setSelectedIndex(null), 400);
  }, []);

  const handlePrev = useCallback(() => {
    setSelectedIndex((prev) =>
      prev !== null ? (prev - 1 + sections.length) % sections.length : 0
    );
  }, []);

  const handleNext = useCallback(() => {
    setSelectedIndex((prev) =>
      prev !== null ? (prev + 1) % sections.length : 0
    );
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isZoomed) handleClose();
      if (e.key === 'ArrowLeft' && isZoomed) handlePrev();
      if (e.key === 'ArrowRight' && isZoomed) handleNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isZoomed, handleClose, handlePrev, handleNext]);

  return (
    <div className="w-full h-full bg-space-900">
      <PlanetScene
        selectedIndex={selectedIndex}
        onSelectSection={handleSelect}
        isZoomed={isZoomed}
      />

      <HeroOverlay visible={!isZoomed} />

      <NavigationArrows
        selectedIndex={isZoomed ? selectedIndex : null}
        onSelect={handleSelect}
      />

      {isZoomed && (
        <SectionPanel
          section={selectedIndex !== null ? sections[selectedIndex] : null}
          onClose={handleClose}
          onPrev={handlePrev}
          onNext={handleNext}
          currentIndex={selectedIndex ?? 0}
          totalSections={sections.length}
        />
      )}
    </div>
  );
}
